import { create } from 'zustand';
import type { AppStateResponse, CommonsStats } from './lib/types';

interface LedgerStore {
  deviceId: string;
  state?: AppStateResponse;
  commons?: CommonsStats;
  view: 'play' | 'profile' | 'commons' | 'help';
  humanToken: string;
  loading: boolean;
  toast?: string;
  setDeviceId: (deviceId: string) => void;
  setState: (state: AppStateResponse) => void;
  setCommons: (commons: CommonsStats) => void;
  setView: (view: LedgerStore['view']) => void;
  setHumanToken: (token: string) => void;
  setLoading: (loading: boolean) => void;
  setToast: (toast?: string) => void;
}

export const useLedgerStore = create<LedgerStore>((set) => ({
  deviceId: '',
  view: 'play',
  humanToken: '',
  loading: false,
  setDeviceId: (deviceId) => set({ deviceId }),
  setState: (state) => set({ state, commons: state.commons }),
  setCommons: (commons) => set({ commons }),
  setView: (view) => set({ view }),
  setHumanToken: (humanToken) => set({ humanToken }),
  setLoading: (loading) => set({ loading }),
  setToast: (toast) => set({ toast })
}));
